import React, { FC } from "react";
import { isNullOrWhiteSpace } from "../../utilities/string";
import { Columns } from "../containers/Columns";
import { Container } from "../containers/Container";
import { Shortcut, ShortcutProps } from "../Shortcut";

export type ShortcutSectionProps = {
  subheading?: string;
  heading: string;
  body?: string;
  shortcuts: ShortcutProps[];
};

export const ShortcutSection: FC<ShortcutSectionProps> = ({
  subheading,
  heading,
  body,
  shortcuts
}) => (
  <Container>
    <Columns colSize="full" desktopColSize="10/12" justifyDesktop="justify-center">
      <div className="p-md desktop:p-xxl bg-theme3-400">
        <div className="desktop:w-3/5 mx-auto mb-lg desktop:mb-xxl">
          {!isNullOrWhiteSpace(subheading) && (
            <small className="flex text-stylized text-secondary-300 uppercase mb-xs">
              {subheading}
            </small>
          )}
          {!isNullOrWhiteSpace(heading) && (
            <h2 className="text-h2 font-serif text-secondary-500 mb-sm desktop:mb-md">
              {heading}
            </h2>
          )}
          {!isNullOrWhiteSpace(body) && (
            <p className="text-small desktop:text-medium font-300 text-secondary-400">
              {body}
            </p>
          )}
        </div>
        {!!shortcuts?.length && shortcuts.length > 0 && (
          <div className="flex flex-wrap justify-start gap-sm desktop:gap-md">
            {shortcuts.map((shortcut, i) => (
              <Shortcut key={i} link={shortcut.link}>
                {shortcut.children}
              </Shortcut>
            ))}
          </div>
        )}
      </div>
    </Columns>
  </Container>
);
